import React from 'react';

import { Select } from '@gogame/components';
import { useQuery } from '@gogame/query';

import { loadApplications } from 'scenes/Influencers/InfluencersCampaigns/sources/packages';

const AppSelect = ({ onChange, value }) => {
  const { data, isLoading } = useQuery('rewardApplications', (_, { signal }) =>
    loadApplications({}, { signal })
  );

  return (
    <Select
      value={value}
      onChange={onChange}
      options={data}
      label={'Application'}
      loading={isLoading}
    />
  );
};

export default AppSelect;
